import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';
import { reducer as toastr, ToastrState } from 'react-redux-toastr';
import { combineReducers } from 'redux';
import { reducer as form, FormStateMap } from 'redux-form';

import api, { ApiState } from 'api/reducer';
import blockly, { BlocklyState } from 'store/blockly/reducer';
import field, { FieldState } from 'store/field/reducer';
import file, { FileState } from 'store/file/reducer';
import global, { GlobalState } from 'store/global/reducer';
import licenses, { LicensesState } from 'store/licenses/reducer';
import process, { ProcessState } from 'store/process/reducer';
import processScanConfig, {
  ScanConfigState,
} from 'store/processScanConfig/reducer';
import processScanning, { ScanningState } from 'store/processScanning/reducer';
import registration, { RegistrationState } from 'store/registration/reducer';
import scanDocumentView, {
  ScanDocumentViewState,
} from 'store/scanDocumentView/reducer';
import splitDocuments, {
  SplitDocumentsState,
} from 'store/splitDocuments/reducer';

export interface RootState {
  api: ApiState;
  registration: RegistrationState;
  form: FormStateMap;
  router: RouterState;
  process: ProcessState;
  field: FieldState;
  blockly: BlocklyState;
  processScanConfig: ScanConfigState;
  scanDocumentView: ScanDocumentViewState;
  processScanning: ScanningState;
  file: FileState;
  toastr: ToastrState;
  splitDocuments: SplitDocumentsState;
  global: GlobalState;
  licenses: LicensesState;
}

export default function createRootReducer(history: History) {
  return combineReducers({
    api,
    registration,
    router: connectRouter(history),
    toastr,
    form,
    scanDocumentView,
    licenses,
    process,
    field,
    blockly,
    processScanConfig,
    processScanning,
    file,
    splitDocuments,
    global,
  });
}
